module.exports = __webpack_public_path__ + "static/img/2-9.1454c2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/product/2-9.png
// module id = h/TU
// module chunks = 15